import ProgressUtilityService from '@/services/course/progress-utility-service';
import UserProgressStorageService from '@/services/storage/user-progress-storage-service';
import {
  ActivityProgressCompletionData,
  CourseId,
  CourseProgressEntity,
  SubunitId,
  UnitId,
} from 'course-types';

const ActivityUtilityService = {
  retrieveActivityProgressLocal(
    courseId: string,
    unitId: string | undefined,
    subunitId: string | undefined,
  ) {
    // Get progress cookie
    const progressCookie = ProgressUtilityService.validateCourseDataExists(
      UserProgressStorageService.getUserCourseProgressCookie() || {},
      courseId as CourseId,
      unitId as UnitId,
      subunitId as SubunitId,
    );
    const courseProgressData = progressCookie[courseId as CourseId].completion_data;

    // Locate Activity Data
    const activityData = subunitId
      ? courseProgressData.subunits[subunitId as SubunitId]
      : courseProgressData.units[unitId as UnitId];

    return { progressCookie, activityData };
  },
  updateActivityProgressLocal(
    progressCookie: Record<CourseId, CourseProgressEntity>,
    activityData: ActivityProgressCompletionData,
    courseId: string,
    unitId: string | undefined,
    subunitId: string | undefined,
  ) {
    // Set progress cookie with new data
    if (subunitId) {
      progressCookie[courseId as CourseId].completion_data.subunits[subunitId as SubunitId] = {
        ...activityData,
      };
    } else {
      progressCookie[courseId as CourseId].completion_data.units[unitId as UnitId] = {
        ...activityData,
      };
    }
    UserProgressStorageService.setUserCourseProgressCookie(progressCookie);
  },
  defaultExitContentHandler(
    courseId: string,
    unitId: string | undefined,
    subunitId: string | undefined,
    activityId: string,
    handler: 'video' | 'document',
    incompleteCallback: () => void,
    completeCallback: () => void,
  ) {
    const { progressCookie, activityData } = this.retrieveActivityProgressLocal(
      courseId,
      unitId,
      subunitId,
    );

    if (!activityData[handler][activityId]?.submissionDate) {
      incompleteCallback();
    } else {
      completeCallback();
    }
  },
  async onActivityComplete(
    courseId: string,
    unitId: string | undefined,
    subunitId: string | undefined,
    activityId: string,
    activityType: 'video' | 'document',
  ) {
    // TODO:: re-pull progress if cookie not set / cleared
    //        Edge case where current set method may overwrite database progress
    const { progressCookie, activityData } = this.retrieveActivityProgressLocal(
      courseId,
      unitId,
      subunitId,
    );

    // Define progress if undefined
    if (!activityData[activityType][activityId]) {
      activityData[activityType][activityId] = {};
    }

    // Set submissionDate in DB if undefined
    if (!activityData[activityType][activityId]?.submissionDate) {
      activityData[activityType][activityId].submissionDate = new Date();

      await ProgressUtilityService.updateUserCourseProgressDatabase(
        courseId as CourseId,
        activityData,
        unitId as UnitId,
        subunitId as SubunitId,
      );
    }

    // Set progress cookie with new data
    this.updateActivityProgressLocal(progressCookie, activityData, courseId, unitId, subunitId);
  },
};

export default ActivityUtilityService;
